<template>
    <a href="#content" role="button" id="to-content" tabindex="1" @click.prevent="handleClick" @keydown.enter="handleClick" @keydown.space="handleClick">
        Till innehåll
    </a>
</template>

<script>
export default {
  name: 'ToContent',

  mounted () {

  },

  methods: {
    handleClick: function (e) {
      e.preventDefault()

      window.scroll({
        top: this.calculateOffset(),
        behavior: 'smooth'
      })
    },

    calculateOffset: function () {
      const element = document.getElementById('content')
      return window.pageYOffset + element.getBoundingClientRect().top
    }
  }
}
</script>
